import React from 'react';
import {Select} from "@chakra-ui/react";

const EuropeanCountriesSelect = ({ register }) => {
  const europeanCountries = [
    { code: "AL", name: "Albanien" },
    { code: "AD", name: "Andorra" },
    { code: "BE", name: "Belgien" },
    { code: "BA", name: "Bosnien und Herzegowina" },
    { code: "BG", name: "Bulgarien" },
    { code: "DK", name: "Dänemark" },
    { code: "DE", name: "Deutschland" },
    { code: "EE", name: "Estland" },
    { code: "FI", name: "Finnland" },
    { code: "FR", name: "Frankreich" },
    { code: "GR", name: "Griechenland" },
    { code: "IE", name: "Irland" },
    { code: "IS", name: "Island" },
    { code: "IT", name: "Italien" },
    { code: "XK", name: "Kosovo" },
    { code: "HR", name: "Kroatien" },
    { code: "LV", name: "Lettland" },
    { code: "LI", name: "Liechtenstein" },
    { code: "LT", name: "Litauen" },
    { code: "LU", name: "Luxemburg" },
    { code: "MT", name: "Malta" },
    { code: "MD", name: "Moldawien" },
    { code: "MC", name: "Monaco" },
    { code: "ME", name: "Montenegro" },
    { code: "NL", name: "Niederlande" },
    { code: "MK", name: "Nordmazedonien" },
    { code: "NO", name: "Norwegen" },
    { code: "AT", name: "Österreich" },
    { code: "PL", name: "Polen" },
    { code: "PT", name: "Portugal" },
    { code: "RO", name: "Rumänien" },
    { code: "SM", name: "San Marino" },
    { code: "SE", name: "Schweden" },
    { code: "CH", name: "Schweiz" },
    { code: "RS", name: "Serbien" },
    { code: "SK", name: "Slowakei" },
    { code: "SI", name: "Slowenien" },
    { code: "ES", name: "Spanien" },
    { code: "CZ", name: "Tschechien" },
    { code: "UA", name: "Ukraine" },
    { code: "HU", name: "Ungarn" },
    { code: "VA", name: "Vatikanstadt" },
    { code: "GB", name: "Vereinigtes Königreich" },
    { code: "BY", name: "Weißrussland" }
  ];

  return (
      <Select
          id='country'
          placeholder='Bitte wählen Sie ein Land'
          variant='outline'
          size='sm'
          fontWeight='500'
          borderRadius='16px'
          width='100%'
          size='md'
          {...register}
      >
          {europeanCountries.map((country) => (
              <option key={country.code} value={country.code}>
                  {country.name}
              </option>
          ))}
      </Select>
  );
};

export default EuropeanCountriesSelect;
